import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CheckBoxCompareComponent } from "./check-box-compare.component";
import { I18nModule } from "@spartacus/core";

@NgModule({
 imports:[
    CommonModule,
    FormsModule,
    I18nModule
 ],
  exports:[CheckBoxCompareComponent],
 declarations:[CheckBoxCompareComponent]
})
export class compareCheckBoxModule {

}
